/* Shared entrance motion for chat bubbles and the typing indicator, so they animate identically. */
export const EASE_OUT = [0.16, 1, 0.3, 1] as const;

export const enter = {
  initial: { opacity: 0, y: 6 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.2, ease: EASE_OUT },
} as const;
